import clsx from 'clsx';

type ExitIconProps = {
  className?: string;
};

export const ExitIcon: React.FC<ExitIconProps> = ({ className }) => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={clsx('ExitIcon', className)}
  >
    <path
      d='M8.53384 24.4107L7.58984 23.4667L15.0565 16L7.58984 8.53336L8.53384 7.58936L16.0005 15.056L23.4672 7.58936L24.4112 8.53336L16.9445 16L24.4112 23.4667L23.4672 24.4107L16.0005 16.944L8.53384 24.4107Z'
      fill='#292722'
    />
  </svg>
);
